import Splide from "@splidejs/splide";

export default class CategoriesSlider {
    constructor() {
        this.categorySlider = "";
        this.slider = document.querySelector(".categories-carousel__slider");
        this.events();
    }

    events() {
        window.addEventListener("DOMContentLoaded", () => {
            if (this.slider) {
                this.initializeCategoriesSlider();
            }
        });
    }

    initializeCategoriesSlider() {
        this.mainSlider = new Splide(this.slider, {
            type: "loop",
            perPage: 7,
            perMove: 1,
            pagination: false,
            gap: 35,
            trimSpace: true,
            breakpoints: {
                1280: {
                    arrows: false,
                },
                768: {
                    arrows: false,
                    perPage: 4,
                    padding: {
                        right: "5 rem",
                    },
                },
                576: {
                    arrows: false,
                    perPage: 2,
                    padding: {
                        right: "2 rem",
                    },
                },
            },
        }).mount();
    }
}
